exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-btn {\n    margin-bottom: 5px;\n    margin-right: 5px;\n    padding: 3px 5px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/projects/project/project.component.css
// module id = ../../../../../src/app/projects/project/project.component.css
// module chunks = main